<template>
  <div class="flex flex-col">
    <h2>Solicitudes para adelantar órdenes</h2>

    <div class="flex flex-col lg:flex-row gap-4 lg:gap-6 mt-4 items-start">
      <status-side-nav :options="statusNavOptions" />

      <div class="flex-1 min-w-0 w-full">
    <custom-search
      class="mt-6 w-full sm:w-[500px]"
      placeholder="Buscar por Cliente"
      v-model="searchText"
      @confirm="search"
      @clear="search"
    />

    <div class="card mt-6">
      <table class="table-auto text-sm mt-2 bg-white">
        <thead class="text-left">
          <tr class="bg-gray-100">
            <th class="p-2 rounded-l-lg">ID</th>
            <th class="p-2">Cliente</th>
            <th class="p-2 rounded-r-lg">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="orderRequest in orderRequests" :key="orderRequest.id">
            <td class="p-2">
              {{ orderRequest.id }}
            </td>
            <td class="p-2">
              <router-link
                :to="{
                  name: 'clientsDetail',
                  params: { id: orderRequest.client.id },
                }"
                class="underline system-button"
                >{{ orderRequest.client.name }}
                {{ orderRequest.client.last_name }}</router-link
              >
            </td>
            <td class="p-2">
              <div class="flex">
                <router-link
                  :to="{
                    name: 'orderRequestsDetail',
                    params: { id: orderRequest.id },
                  }"
                  class="secondary-button"
                  >Detalle</router-link
                >
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <div v-if="loading" class="flex w-full h-full items-center">
        <loader-icon class="h-10 w-10 text-primary-500 mx-auto"></loader-icon>
      </div>
    </div>

    <pagination
      :current-page="currentPage"
      :total-pages="totalPages"
      @page-change="onPageChange"
    />
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import Pagination from "@/components/ui/Pagination.vue";
import StatusSideNav from "@/components/ui/StatusSideNav";
export default {
  name: "Order Requests",

  components: {
    Pagination,
    StatusSideNav,
  },

  computed: {
    statusNavOptions() {
      return [
        { status: "pending", label: "Pendientes", icon: "\ud83d\udd50", activeClass: "text-inProcess" },
        { status: "completed", label: "Completadas", icon: "\u2705", activeClass: "text-ready" },
        { status: "rejected", label: "Rechazadas", icon: "\u26d4", activeClass: "text-failed" },
      ].map((option) => ({
        label: option.label,
        icon: option.icon,
        to: { name: "orderRequests", query: { status: option.status } },
        active: this.status === option.status,
        activeClass: option.activeClass,
      }));
    },
  },

  data() {
    return {
      orderRequests: null,
      loading: false,
      status: null,
      searchText: "",
      currentPage: 1,
      totalPages: 0,
    };
  },

  created() {
    this.$store.commit("setSelectedTab", "orderRequests");

    this.status = this.$route.query.status;
    if (!this.status) {
      this.$router.push({
        name: "orderRequests",
        query: { status: "pending" },
      });
    }

    // this.loadOrderRequests();
  },

  methods: {
    async loadOrderRequests() {
      this.loading = true;

      try {
        const response = await api.orderRequests.getByBranch(
          this.$route.params.branchId,
          [
            { name: "status", value: this.status },
            {
              name: "page",
              value: this.currentPage,
            },
            {
              name: "search",
              value: this.searchText,
            },
          ]
        );
        this.orderRequests = response.data;
        this.currentPage = response.current_page;
        this.totalPages = response.last_page;
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loading = false;
    },

    search() {
      this.currentPage = 1;
      this.loadOrderRequests();
    },

    onPageChange(page) {
      this.currentPage = page;
      this.loadOrderRequests();
    },
  },

  watch: {
    "$route.query.status": {
      immediate: true,
      handler(newStatus) {
        this.status = newStatus || "pending";
        this.loadOrderRequests();
      },
    },
  },
};
</script>